<template>
  <div class="grid-container sm:justify-center">
    <Head title="Bienvenida" />
    <div
      class="flex flex-col justify-center gap-4 w-full pt-6 md:pt-14 sm:col-[3_/_-3] md:col-[5_/_-5] xl:col-[3_/_-3]"
    >
      <header class="flex flex-col gap-2">
        <h1 class="headline-sm md:headline-lg text-on-surface">
          Hola, {{ form.fullname.split(' ')[0] }} 👋
        </h1>
        <p class="title-md md:title-lg text-on-surface-variant">
          Te damos la bienvenida al administrador para empresas de nuestra Bolsa de Trabajo
        </p>
      </header>
      <div class="flex flex-col gap-2 text-on-surface-variant title-md md:title-lg">
        <p>Acá podrás gestionar:</p>
        <ul class="list-disc list-inside">
          <li>El stand de tu empresa</li>
          <li>Tus publicaciones de ofertas de empleo</li>
          <li>Descargar curriculums de los candidatos</li>
        </ul>
      </div>
      <p class="label-lg text-on-surface md:title-lg">
        Para continuar con el registro necesitamos que completes los siguientes campos:
      </p>
      <form @submit.prevent="submitForm">
        <TextInput id="fullname" v-model="form.fullname" label="Nombre completo" required />
        <TextInput
          id="position"
          v-model="form.position"
          label="Cargo"
          placeholder="Senior HR Specialist"
          required
        />
        <TextInput
          id="phone_number"
          v-model="form.phone_number"
          label="Número de teléfono"
          placeholder="7200-0000"
        />
        <Button type="submit" class="btn-filled block mx-auto mt-4" :isLoading="form.processing"
          >Continuar</Button
        >
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import evalUserProfileType from '@/evalUserProfileType.mixin.js'
import Layout from '@/Layouts/Layout'
import Button from '@/Components/Button'
import TextInput from '@/Components/FormInputText'

export default {
  name: 'CompanyUserCreate',
  layout: Layout,
  components: { Head, Button, TextInput },
  mixins: [evalUserProfileType],
  props: {
    fullname: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        fullname: this.fullname,
        phone_number: '',
        position: '',
      }),
    }
  },
  methods: {
    submitForm() {
      this.form.post(this.$route('company.user.store'))
    },
  },
}
</script>
